import { useEffect, useState, useContext } from "react";
import { fetchChatSettings } from "../settings-service";
import { settingsMock } from "../consts";
import {
  UserSettingsSchema,
  ChatSettingsType,
  RecommendedPrompt,
} from "../types";
import { UrlParamsContext } from "../../../app/context/url-params-context";
import { transformSettingsToChatSettings } from "../utils";

export const useRequestSettings = () => {
  const { functionKey, username } = useContext(UrlParamsContext);
  const [chatSettings, setChatSettings] = useState<ChatSettingsType>(
    transformSettingsToChatSettings(settingsMock.settings)
  );
  const [recommendedPrompts, setRecommendedPrompts] = useState<
    RecommendedPrompt[]
  >([]);

  useEffect(() => {
    const fetchSettings = async () => {
      try {
        const response = await fetchChatSettings(functionKey, username);
        if (response.ok) {
          const json = await response.json();
          const parsed = UserSettingsSchema.safeParse(json);
          if (!parsed.success) {
            console.error(
              "❌ Invalid convoai_settings_retrieval response — using mock fallback."
            );
            parsed.error.errors.forEach((err) => {
              console.error(`→ [${err.path.join(".")}] ${err.message}`);
            });
            setChatSettings(
              transformSettingsToChatSettings(settingsMock.settings)
            );
            setRecommendedPrompts(settingsMock.recommended_prompt);
            return;
          }
          const responseJson = parsed.data;
          if (responseJson.settings) {
            setChatSettings(
              transformSettingsToChatSettings(responseJson.settings)
            );
          }
          if (
            responseJson.recommended_prompt &&
            responseJson.recommended_prompt.length > 0
          ) {
            setRecommendedPrompts(responseJson.recommended_prompt);
          } else {
            console.warn(
              "Recommended prompts missing or empty — using mock fallback."
            );
            setRecommendedPrompts(settingsMock.recommended_prompt);
          }
        } else {
          const responseText = await response.text();
          console.log("Error", responseText);
          setChatSettings(
            transformSettingsToChatSettings(settingsMock.settings)
          );
          setRecommendedPrompts(settingsMock.recommended_prompt);
        }
      } catch (error: any) {
        console.log("Error", error.message);
        setChatSettings(transformSettingsToChatSettings(settingsMock.settings));
        setRecommendedPrompts(settingsMock.recommended_prompt);
      }
    };
    fetchSettings();
  }, []);
  return {
    chatSettings,
    setChatSettings,
    recommendedPrompts,
  };
};
